import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/src/tiny-slider.scss";

export function sliders() {
	if(!document.getElementsByTagName('body.home')){
		let image = document.getElementById('headerimage').querySelectorAll('.image');

		if (image.length > 1) {
			tns({
				container: '#headerimage',
				mode: 'gallery',
				controls: false,
				nav: false,
				arrowKeys: false,
				items: 1,
				speed: 2000,
				autoplay: true,
				autoplayButton: false,
				autoplayButtonOutput: false,
				autoplayHoverPause: false,
				autoplayTimeout: 5000,
			});
		}
	}
}
